module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "12.8cd44acf.jpeg";